export default __webpack_public_path__ + "static/media/quibbleRM_bg.fab3d736.png";